"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SourceListTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = require("../../constants/Tabs");
var _SourceListTabs = require("./SourceListTabs.styled");
var _Reusable = require("../../constants/Reusable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SourceListTabs = exports.SourceListTabs = function SourceListTabs(_ref) {
  var theme = _ref.theme,
    onTabChanged = _ref.onTabChanged,
    currentTab = _ref.currentTab;
  var presenter = 'speakers';
  var tabs = [presenter, _Tabs.MEDIA];
  var getMediaTitle = function getMediaTitle(tab) {
    if (tab === _Tabs.MEDIA) {
      return 'content';
    }
    return tab;
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceListTabs.TabsContainer, {
    theme: theme
  }, tabs.map(function (tab) {
    return /*#__PURE__*/_react["default"].createElement(_SourceListTabs.Tab, {
      theme: theme,
      "data-testid": tab,
      key: tab,
      isActive: currentTab === tab,
      onClick: function onClick() {
        return onTabChanged(tab);
      },
      tabIndex: "0",
      onKeyDown: function onKeyDown(e) {
        return (0, _Reusable.handleEnterDown)(e, function () {
          return onTabChanged(tab);
        });
      }
    }, getMediaTitle(tab));
  }));
};
SourceListTabs.defaultProps = {
  theme: 'dark'
};
SourceListTabs.propTypes = {
  theme: _propTypes["default"].string,
  currentTab: _propTypes["default"].string,
  onTabChanged: _propTypes["default"].func
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SourceListTabs);